<template>
	<div class="roboto-text">
		<div v-if="!code_sent">
			<div class="is-marged has-text-left">
				<p class="is-marged-top has-text-weight-bold" v-text="translations.rules_title"></p>
				<div class="content is-marged-top is-marged-bottom">
					<p><span class="icon is-marged-right"><i :class="this.password_chars ? 'fa-solid fa-circle-check' : 'fa-thin fa-circle'" style="color: #14cc4d;"></i></span><span v-text="translations.rules.characters"></span></p>
					<p><span class="icon is-marged-right"><i :class="this.password_special ? 'fa-solid fa-circle-check' : 'fa-thin fa-circle'" style="color: #14cc4d;"></i></span><span v-text="translations.rules.special"></span></p>
					<p><span class="icon is-marged-right"><i :class="this.password_number ? 'fa-solid fa-circle-check' : 'fa-thin fa-circle'" style="color: #14cc4d;"></i></span><span v-text="translations.rules.number"></span></p>
					<p><span class="icon is-marged-right"><i :class="this.password_letter ? 'fa-solid fa-circle-check' : 'fa-thin fa-circle'" style="color: #14cc4d;"></i></span><span v-text="translations.rules.letter"></span></p>
				</div>
			</div>
			<div class="is-marged">
				<p class="has-text-weight-bold" v-text="translations.labels.new"></p>
				<div class="control has-icons-right">
					<password
						:placeholder="translations.place_holder"
						classes="input reset-input"
						:tab-index="1"
						@input="passwordChange"
						id="password"
						:validation-icon="true"
						v-bind:passwords-valid="password_valid"
					>
					</password>
				</div>
			</div>
			<div class="is-marged">
				<p class="has-text-weight-bold" v-text="translations.labels.confirm"></p>
				<div class="control has-icons-right is-vertical-align">
					<password
						:placeholder="translations.place_holder"
						classes="input reset-input"
						:tab-index="2"
						@input="passwordConfirmChange"
						id="passwordConfirm"
						:validation-icon="true"
						v-bind:passwords-valid="password_valid"
					>
					</password>
				</div>
				<div>
					<p style="color: red;" v-if="this.show_confirmation_error" v-text="translations.password_doesnt_match"></p>
				</div>
				<div class="control is-marged-top">
					<!-- Used to display error if validation issues occurs for token -->
					<input type="hidden" class="input" name="token" />
				</div>
				<div v-if="display_reset_failed" class="is-marged-top">
					<a style="text-decoration: none;" href="#" @click.prevent="$emit('forgot-password')" v-text="translations.restart"></a>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="is-marged has-text-left">
				<p class="is-marged-top" v-html="destination_message"></p>
			</div>
			<div class="is-marged">
				<div class="is-flex is-flex-direction-row is-marged-top-3em">
					<div class="has-text-left" style="width: 25%;">
						<span class="has-text-weight-bold" v-text="translations.weak_password.code"></span>
					</div>
					<div class="has-text-right" style="width: 100%;">
						<a class="has-text-weight-bold is-info" style="text-decoration: none;" @click.prevent="$emit('resend-code')" v-text="translations.weak_password.resend"></a>
					</div>
				</div>
				<input
						v-model="code"
						type="text"
						:placeholder="translations.weak_password.code_placeholder"
						class="input reset-input">
				<p v-if="code_resent" v-text="translations.weak_password.code_resent"></p>
			</div>
		</div>
		<div class="is-marged column has-text-centered">
			<button style="height: 50px; border: 0; background-color: #F59100; border-radius: 2px;" class="button is-success" v-text="translations.submit" :disabled="!password_valid" @click.prevent="$emit('password-valid', [password, password_confirm, code])">
			</button>
		</div>
	</div>
</template>

<script>
	export default {
		data: function() {
			return {
				password: '',
				password_confirm: '',
				code: ''
			}
		},
		props: {
			translations: {
				type: Object,
				required: true,
			},
			token: {
				type: String,
				required: false,
			},
			code_sent: {
				type: Boolean,
				required: false
			},
			code_resent: {
				type: Boolean,
				required: false
			},
			destination_message: {
				type: String,
				required: false
			},
			display_reset_failed: {
				type: Boolean,
				required: false
			}
		},
		methods: {
			passwordChange: function(pwd)
			{
				this.password = pwd;
			},
			passwordConfirmChange: function(pwd)
			{
				this.password_confirm = pwd;
			}
		},
		computed: {
			passwords_match: function()
			{
				return this.password === this.password_confirm;
			},
			password_chars: function()
			{
				return this.password.length >= 8;
			},
			password_special: function()
			{
				var pattern = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
				return pattern.test(this.password);
			},
			password_number: function()
			{
				var pattern = /[0-9]/;
				return pattern.test(this.password);
			},
			password_letter: function()
			{
				var pattern = /[A-z]/;
				return pattern.test(this.password);
			},
			password_valid: function()
			{
				return this.passwords_match && this.password_chars && this.password_special && this.password_number && this.password_letter;
			},
			show_confirmation_error: function()
			{
				return !this.passwords_match && this.password_confirm !== '';
			}
		},
		name: "reset-password",
	}
</script>

<style scoped>
</style>
